import script from "./LoadingPageOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingPageOverlay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__